import React from 'react';

interface StirIconProps {
  className?: string;
}

const StirIcon: React.FC<StirIconProps> = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M18.8431 3.75699C20.076 5.17834 19.4978 6.45591 19.0312 6.93356L14.5 11M18.8431 3.75699C18.7876 3.69306 18.7285 3.62884 18.6656 3.56438M18.8431 3.75699C17.4547 2.49481 16.2068 3.08673 15.7402 3.56438L12 8M18.8431 3.75699C18.9055 3.81377 18.9683 3.87428 19.0312 3.93874M8.21696 11.9362L7.33335 12.9195C7.33335 12.9195 4.99324 11.8711 2.94549 15.1654C1.27811 17.8478 2.21022 19.6617 2.76963 20.2121C3.30723 20.7848 5.07907 21.739 7.69924 20.0321C10.9171 17.9357 9.89308 15.54 9.89308 15.54L10.8535 14.6354M17.9853 12.2304L19.4932 10.0945L22 11.6381M19.5367 10.1128C20.2262 11.1716 21.0881 13.6069 19.0195 14.8775C16.951 15.9363 11.8831 15.6187 8.15967 5.87746" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default StirIcon;